// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BasePublicFactory instead of class inheritance

import { createBasePublic, type IBasePublic } from "../BasePublicFactory";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import type { FetchSiteTextsParams, FetchSiteTextsResponse } from "./SiteTexts";

interface SiteTextsInstance {
	fetchPublished(params?: FetchSiteTextsParams): Promise<FetchSiteTextsResponse>;
}

// Module-level singleton instance
let instance: SiteTextsInstance | null = null;
let basePublicInstance: IBasePublic | null = null;

function createSiteTexts(): SiteTextsInstance {
	if (!basePublicInstance) {
		basePublicInstance = createBasePublic();
	}

	const basePublic = basePublicInstance;

	return {
		fetchPublished: async (params: FetchSiteTextsParams = {}): Promise<FetchSiteTextsResponse> => {
			const url = new URL(`${basePublic.namespaceUrl}/site-texts`);

			if (params.locale) {
				url.searchParams.set("locale", params.locale);
			}

			if (params.scopes?.length) {
				url.searchParams.set("scope", params.scopes.join(","));
			}

			if (params.textKeys?.length) {
				url.searchParams.set("keys", params.textKeys.join(","));
			}

			try {
				return await basePublic.getRequest<FetchSiteTextsResponse>(url);
			} catch (error) {
				LoggerService.error("❌ [SiteTextsApi] Failed to fetch published site texts", {
					error,
					url: url.toString(),
					params,
				});
				throw error;
			}
		},
	};
}

export function getSiteTextsInstance(): SiteTextsInstance {
	if (!instance) {
		instance = createSiteTexts();
	}
	return instance;
}
